interface MenuButtonProps {
  open: boolean;
  onClick: () => void;
  /** Adapta el color cuando el header está sobre el hero oscuro. */
  light?: boolean;
  className?: string;
}

/**
 * Botón de menú con estilo escalonado (líneas de distinta longitud),
 * no el clásico hamburger de tres barras iguales. Al abrir se transforma
 * en una "X" con una transición suave.
 */
export default function MenuButton({ open, onClick, light = false, className = "" }: MenuButtonProps) {
  const frameClass = light
    ? "border-background-50/25 bg-background-50/10 text-background-50 hover:bg-background-50/20"
    : "border-background-300 bg-background-50 text-foreground-700 hover:bg-background-100";

  const lineBase = "block h-[2px] rounded-full bg-current transition-all duration-300 ease-out";

  return (
    <button
      type="button"
      onClick={onClick}
      aria-label={open ? "Cerrar menú" : "Abrir menú"}
      aria-expanded={open}
      className={`flex h-10 w-10 items-center justify-center rounded-md border transition-colors duration-200 cursor-pointer focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary-400 ${frameClass} ${className}`}
    >
      <span className="relative flex h-[14px] w-[22px] flex-col justify-between" aria-hidden="true">
        <span
          className={`${lineBase} ${open ? "w-[22px] translate-y-[6px] rotate-45" : "w-[22px]"}`}
        ></span>
        <span
          className={`${lineBase} ${open ? "w-0 translate-x-[11px] opacity-0" : "w-[14px] translate-x-[4px]"}`}
        ></span>
        <span
          className={`${lineBase} ${open ? "w-[22px] -translate-y-[6px] -rotate-45" : "w-[7px] translate-x-[11px]"}`}
        ></span>
      </span>
    </button>
  );
}